export const MANAGE_SUBSCRIPTION_URL = '/profile/settings#tab-settings-subscription'
